<template>
  <div class="common-error-hint">
    <i class="common-error-hint-icon icon-font-exclamation" />
    <div class="common-error-hint-title">
      {{ title }}
    </div>
    <span class="common-error-hint-description">
      {{ description }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'CommonErrorHint',
  props: {
    title: {
      type: String,
      default: '載入數據時發生錯誤',
    },
    description: {
      type: String,
      default: '請重新整理頁面試試',
    },
  },
}
</script>

<style lang="scss" scoped>
.common-error-hint {
  text-align: center;
}

.common-error-hint-icon {
  display: block;
  margin: 0 auto;
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
  border: 3px solid;
  text-align: center;
  vertical-align: middle;
  color: #939393;
  border-radius: 50%;
  box-sizing: content-box;

  &:before {
    line-height: inherit;
  }

  @media screen and (min-width: 48em) {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  @media screen and (min-width: 64em) {
    width: 42px;
    height: 42px;
    line-height: 42px;
    font-size: 22px;
  }
}
.common-error-hint-title {
  font-size: 1.125rem;
  font-weight: bold;
  margin: 1rem 0 3px;

  @media screen and (min-width: 64em) {
    font-size: 1.5rem;
  }
}

.common-error-hint-description {
  font-size: .875rem;
}

</style>
